// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b85c0f27","732":"160b11f2","977":"324d54ee"}[chunkId] + ".chunk.js";
};